// Generated by scripts/build-ui-icons.mjs.
export { MapPinArea as default } from "../ui/glyphs-5";
